var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcPdf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.12443 0.00976563H14.1484L20.949 7.09823V20.8853C20.949 22.6125 19.5517 24.0098 17.8306 24.0098H6.12443C4.3973 24.0098 3 22.6125 3 20.8853V3.13419C2.99997 1.40706 4.39727 0.00976562 6.12443 0.00976562V0.00976563Z",
    fill: "#B71D18"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.1426 0.00976562V7.04425H20.9492L14.1426 0.00976562Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.47266 17.9168V13.533H8.33773C8.7995 13.533 9.16533 13.6589 9.44119 13.9168C9.71704 14.1686 9.85499 14.5105 9.85499 14.9363C9.85499 15.362 9.71704 15.7039 9.44119 15.9558C9.16533 16.2136 8.7995 16.3396 8.33773 16.3396H7.5941V17.9168H6.47266ZM7.5941 15.3861H8.21179C8.3797 15.3861 8.51164 15.3501 8.60161 15.2661C8.69155 15.1882 8.73955 15.0802 8.73955 14.9363C8.73955 14.7924 8.69158 14.6844 8.60161 14.6065C8.51167 14.5225 8.37973 14.4865 8.21179 14.4865H7.5941V15.3861ZM10.3167 17.9168V13.533H11.87C12.1758 13.533 12.4637 13.5749 12.7335 13.6649C13.0034 13.7548 13.2493 13.8808 13.4651 14.0547C13.681 14.2226 13.855 14.4505 13.9809 14.7384C14.1008 15.0262 14.1668 15.3561 14.1668 15.7279C14.1668 16.0937 14.1009 16.4235 13.9809 16.7114C13.855 16.9992 13.681 17.2271 13.4651 17.395C13.2492 17.5689 13.0034 17.6949 12.7335 17.7848C12.4637 17.8748 12.1758 17.9168 11.87 17.9168H10.3167ZM11.4142 16.9633H11.738C11.9119 16.9633 12.0739 16.9453 12.2238 16.9033C12.3677 16.8613 12.5056 16.7953 12.6376 16.7054C12.7635 16.6154 12.8655 16.4895 12.9374 16.3216C13.0094 16.1537 13.0454 15.9557 13.0454 15.7279C13.0454 15.494 13.0094 15.2961 12.9374 15.1282C12.8655 14.9603 12.7635 14.8343 12.6376 14.7444C12.5056 14.6544 12.3677 14.5884 12.2238 14.5465C12.0739 14.5045 11.9119 14.4865 11.738 14.4865H11.4142V16.9633ZM14.7305 17.9168V13.533H17.849V14.4865H15.852V15.1881H17.4472V16.1357H15.852V17.9168H14.7305Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPdf);
export default __webpack_public_path__ + "static/media/ic_pdf.2dfd4cb99ef3f0b20efc31e5d6362c4e.svg";
export { ForwardRef as ReactComponent };